module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.descricao),
      expression: "filtro.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtro.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.filtro.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Posição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.posicao),
      expression: "filtro.posicao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtro.posicao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "posicao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Tipo")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.tipo),
      expression: "filtro.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "card",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.filtro.tipo, "card")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filtro, "tipo", "card")
      }
    }
  }), _vm._v("Card")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.tipo),
      expression: "filtro.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "quickyreply"
    },
    domProps: {
      "checked": _vm._q(_vm.filtro.tipo, "quickyreply")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filtro, "tipo", "quickyreply")
      }
    }
  }), _vm._v("Botão Rápido")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.tipo),
      expression: "filtro.tipo"
    }],
    attrs: {
      "type": "radio",
      "value": "text"
    },
    domProps: {
      "checked": _vm._q(_vm.filtro.tipo, "text")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filtro, "tipo", "text")
      }
    }
  }), _vm._v("Texto")])])]), _c('br'), _vm._v(" "), _vm._l((_vm.filtro.opcoes), function(op, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filtro.tipo !== 'text'),
        expression: "filtro.tipo !== 'text'"
      }]
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Opção " + _vm._s(index + 1))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (op.opcao),
        expression: "op.opcao"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (op.opcao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(op, "opcao", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.filtro.tipo === 'card') ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Imagem")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "id": 'file-filtro-' + index
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3",
      staticStyle: {
        "margin-top": "3em",
        "cursor": "pointer"
      }
    }, [(index === _vm.filtro.opcoes.length - 1) ? _c('a', {
      on: {
        "click": _vm.adicionarOpcao
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("Adicionar Opção")])]) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.removerOpcao(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("Remover Opção")])])])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.filtro.ativo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "ativo", $$v)
      },
      expression: "filtro.ativo"
    }
  })], 1)]), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/filtros"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.gravando),
      expression: "habilitaGravar && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb1de24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Filtros/novoFiltro.vue
// module id = 1212
// module chunks = 1